import { createSlice } from '@reduxjs/toolkit';
import { getLocal } from '@utils/storage';

const persisted = getLocal('user');

const initialState = {
    user: persisted ?? null,
    isLoggedIn: persisted?.isLoggedIn ?? false,
    activeSubscription: persisted?.activeSubscription ?? false,
    activeTradeSubscription: persisted?.activeTradeSubscription ?? false,
    brokerLoggedIn: persisted?.brokerLoggedIn ?? false,
    subscriptionValidTill: persisted?.subscriptionValidTill ?? null,
    tradeSubscriptionValidTill: persisted?.tradeSubscriptionValidTill ?? null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, { payload }) => {
            state.user = payload;
            state.isLoggedIn = true;
            state.activeSubscription = payload.activeSubscription ?? false;
            state.activeTradeSubscription = payload.activeTradeSubscription ?? false;
            state.brokerLoggedIn = payload.brokerLoggedIn ?? false;
            state.subscriptionValidTill = payload.subscriptionValidTill ?? null;
            state.tradeSubscriptionValidTill = payload.tradeSubscriptionValidTill ?? null;
        },
        updateSubscriptionStatus: (state, { payload }) => {
            state.activeSubscription = payload.activeSubscription ?? state.activeSubscription;
            state.activeTradeSubscription = payload.activeTradeSubscription ?? state.activeTradeSubscription;
            state.subscriptionValidTill = payload.subscriptionValidTill ?? state.subscriptionValidTill;
            if (state.user) {
                state.user.activeSubscription = state.activeSubscription;
                state.user.activeTradeSubscription = state.activeTradeSubscription;
            }
        },
        setBrokerStatus: (state, { payload }) => {
            state.brokerLoggedIn = payload;
            if (state.user) state.user.brokerLoggedIn = payload;
        },
        logout: () => initialState,
    },
});

export const {
    setCredentials,
    updateSubscriptionStatus,
    setBrokerStatus,
    logout,
} = authSlice.actions;

export default authSlice.reducer;